var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHatchback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 27,
    viewBox: "0 0 70 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60255 15.2379C-0.557446 19.9779 3.15255 22.1129 5.27755 22.5879L5.94735 22.6153C5.85338 22.1963 5.8038 21.7605 5.8038 21.3131C5.8038 18.0409 8.45651 15.3881 11.7288 15.3881C15.0011 15.3881 17.6538 18.0409 17.6538 21.3131C17.6538 21.9298 17.5596 22.5245 17.3848 23.0836L18.1025 23.1129H51.5315C51.3508 22.5453 51.2532 21.9406 51.2532 21.3131C51.2532 18.0409 53.906 15.3881 57.1782 15.3881C60.4505 15.3881 63.1032 18.0409 63.1032 21.3131C63.1032 21.9406 63.0057 22.5453 62.8249 23.1129H64.0775C65.4525 22.0879 68.3525 19.4979 68.9525 17.3379C69.5525 15.1779 68.0525 13.9379 67.2275 13.5879V9.08794L61.8275 2.26291C56.6275 1.61291 44.5325 0.417912 37.7525 0.837912C30.9725 1.25791 21.8275 5.76291 18.1025 7.96291C13.5025 8.41291 3.76255 10.4979 1.60255 15.2379ZM24.6284 6.46279V9.91279L44.3534 8.78783C44.3534 8.78783 44.2934 4.50037 44.3534 2.70037C36.3501 1.80046 30.3501 3.97534 24.6284 6.46279ZM46.8287 8.41282V2.78782C50.2254 3.07537 56.2254 3.60257 57.3504 3.90037C58.4754 4.19816 57.2321 7.30027 56.1287 7.66282C55.2347 7.95661 51.3079 8.16825 48.5336 8.31778C47.8843 8.35278 47.2981 8.38437 46.8287 8.41282Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7266,
    cy: 21.4626,
    r: 3.975,
    stroke: "#BABABA",
    strokeWidth: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.1777,
    cy: 21.4626,
    r: 3.975,
    stroke: "#BABABA",
    strokeWidth: 1.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchback);
export default ForwardRef;